import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { VariantPickerSharedProperties } from "../utils";
import { SerializedStyles } from "@emotion/react";
import React from "react";
import { SwarovskiLink } from "../../../../../components/_shared-components/ui-elements/SwarovskiLink";

export const InternalLinkOrButtonForPickers: ReactTFC<{
  action: VariantPickerSharedProperties["target"];
  attachStyles?: SerializedStyles;
  className?: string;
  children: React.ReactNode;
}> = props => {
  switch (props.action.tag) {
    case "link": {
      return (
        <SwarovskiLink
          link={props.action.link}
          scrollToTop={false}
          expectSimilarLayout={true}
          styled={"no-decoration"}
          isInternal={true}
          attachStyles={props.attachStyles}
          className={props.className}
        >
          {props.children}
        </SwarovskiLink>
      );
    }
    case "click": {
      return (
        <button onClick={props.action.onClick.action} css={props.attachStyles} className={props.className}>
          {props.children}
        </button>
      );
    }
    case "disabled": {
      return (
        <button disabled={true} css={props.attachStyles} className={props.className}>
          {props.children}
        </button>
      );
    }
  }
};
